module.exports = __webpack_public_path__ + "fonts/dFa6ZfeM_74wlPZtksIFajQ6_V6LVlBKdA.woff2";